export const logEvent = (type, e) => console.log(`DEBUG (events) (${type}):`, e)